<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="align-left">
            <small class="text-muted">Treatment</small>
        </h3>
        <div class="dropdown-divider"></div><br />
        <app-modal :elements="modalElements" v-on:confirm="del"></app-modal>
        <app-data-search v-on:searching="search"></app-data-search>
        <button v-if="this.role === 'admin'" type="button" class="btn btn-outline-primary" @click="add">Add  <i class="far fa-file"></i></button>
        <button type="button" class="btn btn-outline-info" @click="edit" style="margin-left: 20px;">Edit <i class="far fa-edit"></i></button>
        <!-- <button type="button" class="btn btn-outline-success" @click="preview">Preview <i class="fas fa-print"></i></button> -->
        <div style="float:right;">
            <!-- <button type="button" class="btn btn-outline-danger" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Delete <i class="far fa-trash-alt"></i></button> -->
        </div>
        <br /><br />
        <app-datatable :type="'view'" :elements="dtElements" :collections="treatment" v-on:selectedRow="selectRow"></app-datatable>
        <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { Treatment } from '../../models/treatment'
import AppDatatable from '../../components/AppDatatable.vue'
import AppModal from '../../components/AppModal.vue'
import AppDataPagination from '../../components/AppDataPagination.vue'
import AppDataSearch from '../../components/AppDataSearch.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppDatatable, AppModal, AppDataPagination, AppDataSearch, AppNavBar
    },
    data() {
        return {
            treatment: [Treatment],
            dtElements: [
                {
                    title: 'Code',
                    column: 'name',
                    type: 'text'
                },
                {
                    title: 'Treatment Name',
                    column: 'remarks',
                    type: 'text'
                },
                {
                    title: 'Treatment Price',
                    column: 'price',
                    type: 'currency'
                },
            ],
            modalElements: {
                modalId: 'treatment',
                title: 'Confirm',
                content: 'Are you sure to delete this data?',
                type: 'text-confirm'
            },
            role: '',
            selectedId: '',
            searchKey: '',
            pagination: {
                pageSize: 10,
                currentPage: 1
            }
        }
    },
    async created() {
        this.init()
    },
    methods: {
        async init() {
            const trtApi = api('treatment/partial')
            const query = {
                params: {
                    searchKey: this.searchKey,
                    currentPage: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize
                }
            }
            // this.treatment = await trtApi.getWithQuery(query) 

            const treatmentResult = await trtApi.getWithQuery(query) 
            this.treatment = treatmentResult[0]
            this.role = treatmentResult[1]
        },
        add() {
            this.$router.push({ name: 'treatmentDetail' })
        },
        edit() {
            if(this.selectedId !== '') {
                this.$router.push({
                    name: 'treatmentDetail',
                    query: {
                        id: this.selectedId
                    }
                })
            }
        },
        async del() {
            if(this.selectedId !== '') {
                const trtApi = api('treatment')
                await trtApi.delete(this.selectedId)
                this.init()
            }
        },
        selectRow(id) {
            this.selectedId = id
        },
        changePage(payload) {
            this.pagination = payload
            this.init()
        },
        search(searchKey) {
            this.searchKey = searchKey
            this.init()
        }
    }
}
</script>